import { render, staticRenderFns } from "./w2pPintura.vue?vue&type=template&id=3bcc1159"
import script from "./w2pPintura.vue?vue&type=script&lang=js"
export * from "./w2pPintura.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./w2pPintura.vue?vue&type=style&index=0&id=3bcc1159&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./w2pPintura.vue?vue&type=style&index=1&id=3bcc1159&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)
var style2 = require("./w2pPintura.vue?vue&type=style&index=2&id=3bcc1159&prod&lang=scss")
if (style2.__inject__) style2.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports